import { Filter } from '../types/Filter';

export const testIsEmptyFilter = (filter: Filter): boolean =>
  !filter.operatorId && filter.values.length === 0;
